import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BaseService } from './../../../core/services/base.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';
import { NotificationService } from '@optsolservices/ngx-notification';

@Component({
  selector: 'app-syspro-order-line-dialog',
  templateUrl: './syspro-order-line-dialog.component.html',
  styleUrls: ['./syspro-order-line-dialog.component.scss']
})
export class SysproOrderLineDialogComponent implements OnInit {
  warehouses: {
    availableStock: number;
    deliveryMethods: {
      deliveryMethodDesc: string;
      deliveryMethodId: number;
    }[];
    warehouseCode: string;
    warehouseDesc: string;
  }[] = [];

  warehouse: {
    availableStock: number;
    deliveryMethods: {
      deliveryMethodDesc: string;
      deliveryMethodId: number;
    }[];
    warehouseCode: string;
    warehouseDesc: string;
  };

  deliveryMethods: {
    deliveryMethodDesc: string;
    deliveryMethodId: number;
  }[] = [];

  form: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<SysproOrderLineDialogComponent>,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private fb: FormBuilder
  ) {
    this.form = fb.group({
      salesOrderNumber: [null, Validators.compose([Validators.required])],
      lineNumber: [null, Validators.compose([Validators.required])],
      stockCode: [null, Validators.compose([Validators.required])],
      lineDescription: [null, Validators.compose([Validators.required])],
      lineDescription2: [null, Validators.compose([Validators.required])],
      orderQty: [null, Validators.compose([Validators.required, Validators.min(1)])],
      availableQty: [0],
      warehouseCode: [null, Validators.compose([Validators.required])],
      deliveryMethodId: [null, Validators.compose([Validators.required])],
      partCategory: [null, Validators.compose([Validators.required])],
      leadTime: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.form.patchValue(this.data);

    this.form.controls['lineNumber'].disable();
    this.form.controls['stockCode'].disable();
    this.form.controls['lineDescription'].disable();
    this.form.controls['lineDescription2'].disable();
    this.form.controls['availableQty'].disable();
    this.form.controls['partCategory'].disable();
    this.form.controls['leadTime'].disable();

    this.baseService.executeCommand<any[]>('portal_syspro_order_line_dialog_config', {
      salesOrderNumber: this.data.salesOrderNumber,
      lineNumber: this.data.lineNumber
    }).subscribe(response => {
      if (response.responseCode === 0) {
        this.warehouses = response.data || [];
        this.warehouse = this.warehouses.find(f => f.warehouseCode === this.form.value.warehouseCode);
        if (this.warehouse) {
          this.deliveryMethods = this.warehouse.deliveryMethods || [];
          this.form.controls['availableQty'].setValue(this.warehouse.availableStock);
        }
      }
    });
  }

  save() {
    const dialogData: OiGroupDialogData = {
      title: 'Updating line warehouse and quantity from the order in SYSPRO',
      function: 'portal_oi_group_syspro_order_line_warehouse_qty_modify',
      postBody: {
        salesOrderNumber: this.data.salesOrderNumber,
        lineNumber: this.form.getRawValue().lineNumber,
        qty: this.form.value.orderQty,
        warehouseCode: this.form.value.warehouseCode,
        deliveryMethodId: this.form.value.deliveryMethodId
      }
    };

    const ref = this.dialog.open(OiGroupProcessDialogComponent, {
      data: dialogData,
      width: '450px'
    });

    ref.afterClosed().subscribe(oiResult => {
      if (oiResult.responseCode === 0) {
        this.notificationService.success('Line Warehouse and Quantity Updated');
        this.dialogRef.close();
      }
    });

    // this.baseService.executeCommand<any[]>('portal_oi_group_syspro_order_line_warehouse_qty_modify',
    //   {
    //     salesOrderNumber: this.data.salesOrderNumber,
    //     lineNumber: this.form.getRawValue().lineNumber,
    //     qty: this.form.value.orderQty,
    //     warehouseCode: this.form.value.warehouseCode,
    //     deliveryMethodId: this.form.value.deliveryMethodId
    //   })
    //   .subscribe(response => {
    //     if (response.responseCode === 0) {
    //       this.dialogRef.close(true);
    //     }
    //   });
  }

  warehouseChanged(event: MatSelectChange) {
    this.warehouse = this.warehouses.find(f => f.warehouseCode === this.form.value.warehouseCode);
    this.form.controls['deliveryMethodId'].reset();
    this.form.controls['availableQty'].reset();

    if (this.warehouse) {
      this.deliveryMethods = this.warehouse.deliveryMethods || [];
      this.form.controls['availableQty'].setValue(this.warehouse.availableStock);
    }
  }

}
